var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 31 35",
    width: 31,
    height: 35,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "s0",
    d: "m16 22c-3.9 0-7-3.1-7-7 0-3.9 3.1-7 7-7 3.9 0 7 3.1 7 7 0 3.9-3.1 7-7 7z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "s1",
    d: "m29.6 15c0 9.4-12.4 17.3-13 17.6l-0.8 0.5-0.8-0.5c-0.5-0.3-13-8.2-13-17.6 0-3.7 1.5-7.2 4-9.8 2.6-2.6 6.2-4.1 9.8-4.1 3.7 0 7.2 1.5 9.8 4.1 2.6 2.6 4 6.1 4 9.8zm-8.2 0c0-1.5-0.6-3-1.6-4-1.1-1.1-2.5-1.7-4-1.7-1.5 0-2.9 0.6-4 1.7-1 1-1.6 2.5-1.6 4 0 1.5 0.6 2.9 1.6 3.9 1.1 1.1 2.5 1.7 4 1.7q1.1 0 2.2-0.4 1-0.5 1.8-1.3c1-1 1.6-2.4 1.6-3.9z",
    fill: "#d44333",
    stroke: "#000000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPin);
export default __webpack_public_path__ + "static/media/Pin.1fa92dfc8fe4e0cb120cf73dcd6fa963.svg";
export { ForwardRef as ReactComponent };